import React from 'react';

const KOALENDAR = 'https://koalendar.com/e/meet-with-mark-bernstein';

// Partner organisations the platform's fractional CFOs come from — follows the "…on the platform from" line.
const PARTNER_LOGOS = [
    { src: require('../../../../images/landing-pages/fractional/fractionality.png'), alt: 'Fractionality' },
    { src: require('../../../../images/landing-pages/fractional/ascentis.png'), alt: 'Ascentis' },
    { src: require('../../../../images/landing-pages/fractional/cfo-centre.jpg'), alt: 'The CFO Centre' },
    { src: require('../../../../images/landing-pages/fractional/fd-consultant.png'), alt: 'The FD Consultant' },
];

const FractionalHeroSection = () => {
    return (
        <section className="lp-hero">
            <div className="lp-hero-glow lp-glow-anim" aria-hidden="true" />
            <div className="lp-hero-inner">
                <div className="lp-hero-copy">
                    <div className="lp-badge" data-lp-reveal><span />For fractional CFOs</div>
                    <h1 className="lp-h1" data-lp-reveal data-lp-delay="60">The AI-powered toolkit that makes you indispensable</h1>
                    <p className="lp-lead" data-lp-reveal data-lp-delay="120">Free for advisors.&nbsp; Built for your whole client book. Let's show you how you can add value to your clients immediately.</p>
                    <div className="lp-cta-row" data-lp-reveal data-lp-delay="180">
                        <a className="lp-btn lp-btn--primary" href={KOALENDAR} target="_blank" rel="noopener noreferrer">Book a 30-min call</a>
                        <a className="lp-btn lp-btn--ghost" href="#process">See how it works ↓</a>
                    </div>
                    <div className="lp-hero-social" data-lp-reveal data-lp-delay="240">
                        <div className="lp-avatars">
                            <img src={require('../../../../images/fractional/testimonial/leftTestimonial.svg')} alt="" />
                            <img src={require('../../../../images/fractional/testimonial/centerTestimonial.svg')} alt="" />
                            <img src={require('../../../../images/fractional/testimonial/rightTestimonial.svg')} alt="" />
                        </div>
                        Join 80+ fractional CFOs already on the platform from
                    </div>
                    {/* Each logo sits in an equal circular frame — the source files differ in shape
                        (Fractionality is a full-bleed rectangle, Ascentis a square padded with white),
                        so a radius on the image alone gives ellipses and rounded squares. */}
                    <div className="lp-hero-logos" data-lp-reveal data-lp-delay="300">
                        {PARTNER_LOGOS.map(l => (
                            <span className="lp-hero-logo" key={l.alt}>
                                <img src={l.src} alt={l.alt} />
                            </span>
                        ))}
                    </div>
                </div>

                <div className="lp-hero-art">
                    <div className="lp-hero-stage">
                        <img className="lp-hero-photo" src={require('../../../../images/landing-pages/fractional/fractional-top-banner.png')} alt="Fractional CFO" />
                        <div className="lp-hero-card lp-float" data-lp-reveal data-lp-delay="200">
                            <div className="lp-hero-card-top">
                                <div className="t">Diligence pack</div>
                                <div className="g">Gold ★</div>
                            </div>
                            <div className="lp-ring">
                                <svg width="148" height="148" viewBox="0 0 148 148" aria-hidden="true">
                                    <circle cx="74" cy="74" r="62" fill="none" stroke="#EEF1FF" strokeWidth="14" />
                                    <circle cx="74" cy="74" r="62" fill="none" stroke="#4A67FF" strokeWidth="14" strokeLinecap="round" strokeDasharray="389.6" strokeDashoffset="155.8" />
                                </svg>
                                <div className="lp-ring-c">
                                    <div className="p">60%</div>
                                    <div className="s">auto-filled</div>
                                </div>
                            </div>
                            <div className="lp-hero-card-row">
                                <span className="d" />
                                <span className="bar" />
                                <span className="l">Review</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FractionalHeroSection;
